// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c22f06f1","545":"27a17e95","787":"46c47474"}[chunkId] + ".chunk.js";
};